












































































































































































































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { Owner } from "@/api/owner/types";
import OwnersList from "./OwnersList.vue";
import * as service from "@/services/owner";
import { OwnerFilter } from "@/api/owner/types";
import { Page } from "@/api/types";
import { PaginatedResponseContent } from "@/api/types";
import AgroTablePagination from "@/components/agroTablePagination/AgroTablePagination.vue";
import { AdmittedFilter } from "@/constants/owner";
import EventBus from "@/event-bus";
import AgroGenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import AgroOnOff from "@/components/agroOnOff/AgroOnOff.vue";
import { formattedAreaInHa } from "@/filters/area";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import OwnersDeleteModalController from "../owners-delete-modal/OwnersDeleteModalController.vue";
import i18n from "@/i18n";

@Component({
  name: "OwnersListController",
  components: {
    AgroTablePagination,
    AgroGenericModal,
    AgroResponsiveTable,
    AgroOnOff,
    AgroIcons,
    OwnersDeleteModalController,
  },
  filters: {
    formattedAreaInHa,
  },
})
export default class OwnersListController extends Vue {
  private searchTimer: any;
  private admittedFilter = AdmittedFilter;
  private page = new Page(0, 20);
  @Prop({ type: Boolean, default: false })
  private mobileFilterModalVisible!: boolean;

  private ownerFilter: OwnerFilter = {...this.ownerFilterStore};

  private columnsLabel: object = {};

  private tableColumns = [
    { name: "name" },
    { name: "ownerKey" },
    { name: "farmCount" },
    { name: "farmArea" },
    { name: "actions" },
  ];

  private owner: Owner | null = null;
  private ownerDeleteModal: boolean = false;

  private prefix: string = "owners.owner-table";

  get owners() {
    return this.$store.state.owner.ownersContext;
  }

  get ownerFilterStore() {
    return this.$store.state.owner.ownersFilter;
  }

  @Watch('ownerFilterStore')
  private onFilterChange(filter: OwnerFilter) {
    this.ownerFilter = this.ownerFilterStore;
  }

  private changeAdmitted(event: any) {
    this.ownerFilter.admitted = event.target.value;
    this.paginateTimeOut(this.page, true);
  }

  private paginateTimeOut(page: Page, immediate: boolean = false) {
    this.page = page;

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    this.searchTimer = setTimeout(this.paginate,
      immediate ? 0 : 800
    );
  }

  private async paginate() {
    await service.fetchAllByFilter(this.ownerFilter, this.page);
  }

  private created() {
    this.columnsLabel = {
      name: i18n.t("owner-table.name"),
      ownerKey: i18n.t("owner-table.ownerKey"),
      farmCount: i18n.t("owner-table.farmCount"),
      farmArea: i18n.t("owner-table.farmArea"),
      actions: i18n.t("owner-table.actions"),
    };
  }

    private async mounted() {
    EventBus.$on("update:owners", this.paginate);
    await this.paginate();
  }
    
  private beforeDestroy() {
    EventBus.$off("update:owners");
  }

  private async setAdmitted(owner: Owner) {
    owner.admitted = !owner.admitted;

    let ownerResponse: Owner = owner;

    if (owner.admitted) {
      ownerResponse = await service.unadmit(owner, true);
    } else {
      ownerResponse = await service.admit(owner, true);
    }

    owner.admitted = ownerResponse.admitted;
  }

  private toggleOwnerDeleteModal() {
    this.ownerDeleteModal = !this.ownerDeleteModal;
  }

  private toggleModalAndSendOwner(owner: Owner) {
    this.ownerDeleteModal = !this.ownerDeleteModal;
    this.owner = owner;
  }

  @Emit("closeFitersMobileModal")
  private onCancel() {}

  private clearFilter = service.clearFilter;
}
